import Vue from 'vue'
import Vuex from 'vuex'
import Public from './modules/public/index'
import Email from './modules/email/index'
Vue.use(Vuex);

export  default new Vuex.Store({
    modules:{
        public:Public,
        email:Email,
    }
})







// WEBPACK FOOTER //
// ./src/vuex/store.js